import { NULL_ADDRESS, UINT32_MAX } from '../utils/constants.mjs';

function mintTieredEditionArgs({
  edition,
  tier,
  scheduleNum,
  to,
  quantity,
  mintParams,
  affiliate = NULL_ADDRESS,
  affiliateProof = [],
  attributionId = 0n
}) {
  const allowlistedQuantity = UINT32_MAX;
  const { allowlisted, allowlistProof } = mintParams.mode === "VERIFY_MERKLE" ? mintParams : { allowlisted: NULL_ADDRESS, allowlistProof: [] };
  const {
    signedPrice,
    signedQuantity,
    signedClaimTicket,
    signedDeadline,
    signature
  } = mintParams.mode === "VERIFY_SIGNATURE" ? mintParams : { signature: NULL_ADDRESS, signedPrice: 0n, signedQuantity: 0, signedClaimTicket: 0, signedDeadline: 0 };
  return [
    {
      edition,
      tier,
      scheduleNum,
      to,
      quantity,
      allowlisted,
      allowlistedQuantity,
      allowlistProof,
      signedPrice,
      signedQuantity,
      signedClaimTicket,
      signedDeadline,
      signature,
      affiliate,
      affiliateProof,
      attributionId
    }
  ];
}

export { mintTieredEditionArgs };
